import React from 'react';
import { IconProps } from '.';

const SvgDiscountTag = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M9 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6.47 14.47l6-6 1.06 1.06-6 6-1.06-1.06ZM12.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M1 4h16.5l5.5 8-5.5 8H1V4Zm1.5 1.5h14.211L21.18 12l-4.469 6.5H2.5v-13Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDiscountTag;
